module.exports = "/_next/static/images/sprite.icons-f94640d34e883abb3ae7755cb0dc46b0.svg";